export default "__VITE_ASSET__C7MVbkVy__"